<template>
  <div class="nasabah">
    <p class="title">Nasabah Blacklist</p>
    <div class="content">
      <table class="table table-striped table-bordered">
        <thead class="text-center">
          <tr>
            <th>No</th>
            <th>Nama Lengkap</th>
            <th>Email</th>
            <th>
              Platform
              <div class="form-group mb-0">
                <select name="" id="" v-model="platform" @change="filterPlatform">
                  <option value="">All</option>
                  <option v-for="(data, i) in dataPlatform" :key="i" :value="data.code">{{ data.name }}</option>
                </select>
              </div>
            </th>
            <th>No Telepon</th>
            <th>No KTP</th>
            <th>NPWP</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <td colspan="9" v-show="loadingData" style="text-align: center">
            <div class="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </td>
          <tr v-for="(data, i) in dataNsb" :key="i" v-show="loadingData == false && dataNsb.length != 0">
            <td>{{ (currentPage - 1) * perPage + (i + 1) }}</td>
            <td>{{ data.fullname ? data.fullname : "-" }}</td>
            <td>
              {{ data.user.email }}
            </td>
            <td>
              <div v-for="platformData in data.platform" :key="platformData.code">
                {{ "- " + platformData.name }}
              </div>
            </td>
            <td>{{ data.user.phonenumber ? data.user.phonenumber : "-" }}</td>
            <td>{{ data.ktp_no ? data.ktp_no : "-" }}</td>
            <td>{{ data.npwp_no ? data.npwp_no : "-" }}</td>
            <td>
              <router-link :to="'/nsb-detail/' + data._id" v-if="checkAccess('get-detail')"
                ><button type="button" class="buttons btn-info btn-xs">
                  Detail
                </button></router-link
              >
              <button
                class="buttons btn-secondary btn-xs"
                @click="unblackList(data._id, data.fullname)"
                v-if="checkAccess('unblock')"
                data-toggle="modal"
                data-target="#createRoom"
              >
                Unblacklist
              </button>
            </td>
          </tr>
          <tr v-show="loadingData == false && dataNsb.length == 0">
            <td colspan="8" class="text-center">No Data</td>
          </tr>
        </tbody>
      </table>
      <b-modal ref="unBlacklist" title="Verifikasi Nasabah">
        <div class="d-block text-center">
          <p class="sub-title-modal">
            Apakah anda yakin untuk unblacklist <b>{{ name }}</b> ?
          </p>
        </div>
        <template #modal-footer>
          <button class="btn btn-scondary" @click="hideModal('unBlacklist')" v-show="!isLoading">
            Cancel
          </button>
          <button class="btn btn-primer" @click="sendApprove" :disabled="isLoading">
            <b-spinner variant="ligth" v-if="isLoading"></b-spinner>
            <div v-else>UnblackList</div>
          </button>
        </template>
      </b-modal>
      <div class="modal fade" id="createRoom" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Unblacklist Nasabah
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p class="sub-title-modal">Apakah anda yakin untuk unblacklist {{ name }}?</p>
            </div>
            <div class="modal-footer">
              <button class="btn btn-scondary" data-dismiss="modal" aria-label="Close">
                Cancel
              </button>
              <button class="btn btn-primer" @click="sendApprove" :disabled="isLoading">
                <b-spinner variant="ligth" v-if="isLoading"></b-spinner>
                <div v-else>UnblackList</div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <b-pagination v-model="currentPage" :total-rows="count_data" :per-page="perPage" aria-controls="new-table" v-show="count_data > 10"></b-pagination>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import Loading from "../../assets/Loading.vue";
export default {
  components: {
    // Loading,
  },
  data() {
    return {
      dataNsb: [],
      currentPage: 1,
      count_data: "",
      perPage: 10,
      id: "",
      isLoading: false,
      loadingData: false,
      name: "",
      platform: "",
      dataPlatform: [],
    };
  },

  mounted() {
    axios.get("/v2/master_data/platform").then((res) => {
      this.dataPlatform = res.data.data;
    });
    this.getData(this.currentPage);
  },
  computed: {
    checkRole() {
      let role = localStorage.getItem("role");
      if (role) {
        return role;
      } else {
        return null;
      }
    },
    paginate() {
      if (!this.dataNsb || this.dataNsb.length != this.dataNsb.length) {
        return;
      }
      // var like = this

      // like.totalPages = this.dataNsb.length
      // if(this.currentPage >= this.totalPages){
      //   like.currentPage = this.totalPages
      // }
      var index = this.currentPage * this.perPage - this.perPage;
      return this.dataNsb.slice(index, index + this.perPage);
    },
  },
  methods: {
    checkAccess(value) {
      let service_access = localStorage.getItem("access");
      let dataAcces = JSON.parse(service_access);
      let returnValue = this.isAccess;
      for (let i = 0; i < dataAcces.length; i++) {
        let access = dataAcces[i].access;
        for (let j = 0; j < access.length; j++) {
          if (access[j] == value) {
            returnValue = true;
          }
        }
      }
      return returnValue;
    },
    filterPlatform() {
      // this.getData(this.value, this.currentPage, this.platform);
    },
    getData(value) {
      let role = localStorage.getItem("role");
      let urlAdmin;
      if (role == "0") {
        urlAdmin = "superadmin";
      } else {
        urlAdmin = "admin-broker";
      }
      this.loadingData = true;
      let setPage = (value - 1) * this.perPage;
      axios.get("/v2/" + urlAdmin + "/kyc/customers?status=6&limit=5&offset=" + setPage).then((res) => {
        // console.log(res);
        this.loadingData = false;
        this.dataNsb = res.data.data.customers;
        this.count_data = res.data.data.total;
      });
    },
    unblackList(id, name) {
      this.id = id;
      this.name = name;
      this.$refs["unBlacklist"].show();
    },
    hideModal(idModal) {
      this.$refs[idModal].hide();
    },
    sendApprove() {
      this.isLoading = true;
      // const dataIP = {
      //   geoplugin_request: window.geoplugin_request(),
      //   geoplugin_city: window.geoplugin_city(),
      // };
      axios
        .put("/v2/admin-broker/kyc/unblock/" + this.id)
        .then((res) => {
          let status = res.data.data.status_code;
          let id_activity = res.data.data.activity_id;
          if (status == "00") {
            this.isLoading = false;
            this.$notify({
              group: "foo",
              title: "<h5>Unblacklist Nasabah berhasil</h5>",
              type: "success",
              duration: 2000,
            });

            this.$store.dispatch("getLocation").then((resGeo) => {
              let info;
              if (resGeo.cityData[0]) {
                info = resGeo;
              } else {
                let data = resGeo;
                data.newLatLong = resGeo.cityLatLong.split(",");
                info = data;
              }
              axios.put("/v2/admin-broker/operator-activity/" + id_activity, info);
            });
            // setTimeout(function() {
            //   location.reload();
            // }, 2000);
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.lds-ring {
  display: inline-block;
  /* position: absolute; */
  width: 30px;
  height: 30px;
  /* top: 4px; */
  /* left: 39%; */
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 30px;
  height: 30px;
  margin: 6px;
  border: 6px solid #1f354a;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #1f354a transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
table {
  color: #707070 !important;
}

.nasabah {
  font-size: 14px;
  padding: 0 20px;
}

.title {
  font-size: 22px;
  font-weight: bold;
  margin: 0 0 60px;
}

.btn {
  margin: 0 10px;
  width: 130px;
  height: 40px;
}
</style>
